<div class="relative container mx-auto mt-12 space-y-8">
  <div *ngIf="!isLoading" class="flex flex-col rounded-xl p-4 ring-1 ring-zinc-900/15 md:p-8 dark:ring-white/10">
    <h1 class="text-3xl text-zinc-900 dark:text-zinc-200">
      {{ pageHeader }}
    </h1>
    <span *ngIf="cycleBanner" class="pb-4 text-cam-blue/80 dark:text-approver-blue">{{
      cycleBanner
      }}</span>
    <p class="pb-4">
      {{ instructions }}
    </p>
    <p class="pb-4">{{ moreInstructions }}</p>
    <p *ngIf="this.id == 0">{{ extraInstructions }}</p>
  </div>
  <div class="flex flex-col gap-2 rounded-xl p-4 ring-1 ring-zinc-900/15 md:p-8 dark:ring-white/10">
    <h2 class="pb-4 text-2xl text-zinc-900 dark:text-zinc-200">
      {{ header }}
    </h2>
    <div class="alert alert-danger alert-dismissible fade show" role="alert" *ngIf="error && !questionsForm.valid">
      {{ error }}
      <button type="button" class="close" data-dismiss="alert" aria-label="Close" (click)="onClose()">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <form [formGroup]="questionsForm" (ngSubmit)="onForward()" class="flex flex-col gap-4">
      <div formArrayName="answers" *ngFor="let answerGroup of answerGroups; let i = index">
        <div [formGroup]="answerGroup" class="form-group grid items-center lg:grid-cols-6">
          <label [for]="'question-' + answerGroup.get('questionNum')?.value" class="lg:col-span-5">
            {{ questions[i]?.Text }}
          </label>
          <div class="flex border-b border-zinc-900/15 pb-2 lg:mb-0 lg:justify-end lg:border-0 dark:border-white/10">
            <input [id]="'question-' + answerGroup.get('questionNum')?.value" formControlName="answer"
              title="Enter numeric value"
              (blur)="onFieldBlur(i)"
              appNumberFormat
              class="flex h-8 w-24 rounded-lg border px-1 py-1 text-end shadow-md shadow-zinc-800/5 focus:border-cam-blue focus:ring-4 focus:ring-cam-blue/10 focus:outline-hidden"
              [ngClass]="{
                'bg-[#f8cfcffa]': answerGroup.get('answer')?.value === null ||
                answerGroup.get('answer')?.value === undefined ||
                answerGroup.get('answer')?.value === '',
              }" min="0" />
          </div>
        </div>
      </div>
      <div class="mt-4 flex justify-center">
        <button [class]="
            questionsForm.valid
              ? 'cursor-pointer justify-center rounded-lg bg-green-700 px-3 py-2 font-semibold text-white outline-offset-2 transition hover:bg-green-600 active:bg-green-700 active:text-green-100/70 active:transition-none'
              : 'cursor-not-allowed justify-center rounded-lg bg-zinc-400 px-3 py-2 font-semibold text-zinc-100 outline-offset-2'
          " [disabled]="!questionsForm.valid" type="submit">
          Save & Continue
        </button>
      </div>
    </form>
  </div>
  <div *ngIf="isLoading" class="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 transform">
    <app-loading-spinner></app-loading-spinner>
  </div>
</div>